import React, { MouseEvent } from 'react'
import { optimizeContentfulImageUrl } from 'web/src/helpers/images'
import { CustomLink } from '../links'
import { Picture } from '../Picture'
import { color } from 'web/src/style/variables'

import { virginRedPath } from 'web/src/router/paths'
import { BrandDetails } from '@vrw/data/src/redux/rewards/types'
import { Prettify } from '@/redux/hooks/type-helpers'
import { media } from 'web/src/style/media'

type BrandCardProps = Prettify<
  { brandLogo: BrandDetails['brandLogo']; brandName: BrandDetails['brandName']; slug: BrandDetails['slug'] } & {
    isSlideChanging: boolean
    handleDragStart: (e: MouseEvent) => void
    handleOnClick: (e: MouseEvent) => (preventDefault: boolean) => void
    responsiveImages: (brandLogo: string) => {
      mobile: {
        imgSrc: string
        hiResImgSrc: string
      }
    }
  }
>

const BrandsCarouselCard = ({
  brandLogo,
  brandName,
  slug,
  handleDragStart,
  handleOnClick,
  responsiveImages,
  isSlideChanging,
}: BrandCardProps) => {
  return (
    <>
      <style jsx>{`
        .logo-container {
          padding: 16px 0;
          background: linear-gradient(to bottom, ${color.darkPinkBackground} 0%, ${color.darkPinkBackground} 50%, white 50%, white 0);
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;
        }
        .logo {
          box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 4px 0px;
          background: white;
          width: 144px;
          height: 144px;
          flex-shrink: 0;
          margin: 0 auto;
        }
        h3 {
          color: ${color.textHeader};
          font-size: 16px;
          margin-top: 0px;
          margin-bottom: 24px;
          font-weight: 600;
        }
        .card {
          width: 242px;
          text-align: center;
          cursor: pointer;
          text-decoration: none;
          margin-top: 15px;
        }
        .card :global(a) {
          margin-right: 16px;
          width: 224px;
          display: inline-block;
          border: 1px solid ${color.lightGrey};
          border-radius: 8px;
          user-select: none;
        }

        @media ${media.tabletAndHigher} {
          .card {
            width: 237px;
          }
          .card :global(a) {
            margin-right: 24px;
            width: 211px;
          }
        }

        @media ${media.desktopAndHigher} {
          h3 {
            font-size: 24px;
          }
          .card {
            width: 334px;
          }
          .card :global(a) {
            width: 318px;
          }
        }
      `}</style>
      <div className="card" onDragStart={handleDragStart}>
        <CustomLink to={`${virginRedPath}/brands/${slug}`} onClick={(e) => handleOnClick(e)(isSlideChanging)}>
          <div className="logo-container">
            <div className="logo">
              <Picture
                altText={`${brandName} logo`}
                className="responsive-img--override"
                width={160}
                fallbackImg={optimizeContentfulImageUrl(brandLogo, 'fill', { width: 144, height: 144 })}
                height={160}
                responsiveImages={responsiveImages(brandLogo)}
                loading={'lazy'}
                isWebP={true}
              />
            </div>
          </div>
          <h3>{brandName}</h3>
        </CustomLink>
      </div>
    </>
  )
}

export default BrandsCarouselCard
